<template>
  <div
      class="main-menu menu-fixed menu-accordion menu-shadow"
      :class="[
      {
        expanded:
          !isVerticalMenuCollapsed ||
          (isVerticalMenuCollapsed && isMouseHovered)
      },
      skin === 'semi-dark' ? 'menu-dark' : 'menu-light'
    ]"
      @mouseenter="updateMouseHovered(true)"
      @mouseleave="updateMouseHovered(false)"
  >
    <!-- main menu header-->
    <div class="navbar-header expanded">
      <slot
          name="header"
          :toggleVerticalMenuActive="toggleVerticalMenuActive"
          :toggleCollapsed="toggleCollapsed"
          :collapseTogglerIcon="collapseTogglerIcon"
      >
        <ul class="nav navbar-nav flex-row">
          <!-- Logo & Text -->
          <li class="nav-item mr-auto">
            <b-link class="navbar-brand" to="/">
              <span class="brand-logo">
                <b-img :src="appLogoImage" alt="logo"/>
              </span>
              <h2 class="brand-text">
                {{ appName }}
              </h2>
            </b-link>
          </li>

          <!-- Toggler Button -->
          <li class="nav-item nav-toggle">
            <b-link class="nav-link modern-nav-toggle">
              <feather-icon
                  icon="XIcon"
                  size="20"
                  class="d-block d-xl-none"
                  @click="toggleVerticalMenuActive"
              />
              <feather-icon
                  :icon="collapseTogglerIconFeather"
                  size="20"
                  class="d-none d-xl-block collapse-toggle-icon"
                  @click="toggleCollapsed"
              />
            </b-link>
          </li>
        </ul>
      </slot>
    </div>
    <!-- / main menu header-->

    <!-- Shadow -->
    <div :class="{ 'd-block': shallShadowBottom }" class="shadow-bottom"/>

    <!-- main menu content-->
    <vue-perfect-scrollbar
        :settings="perfectScrollbarSettings"
        class="main-menu-content scroll-area"
        tagname="ul"
        @ps-scroll-y="
        evt => {
          shallShadowBottom = evt.srcElement.scrollTop > 0;
        }
      "
    >
      <vertical-nav-menu-items
          :items="navMenuItems1"
          class="navigation navigation-main"
      />
    </vue-perfect-scrollbar>
    <!-- /main menu content-->
  </div>
</template>

<script>
//import navMenuItems from '@/navigation/vertical'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import {BImg, BLink} from "bootstrap-vue";
import {computed, provide, ref} from "@vue/composition-api";
import useAppConfig from "@core/app-config/useAppConfig";
import {$themeConfig} from "@themeConfig";
import VerticalNavMenuItems from "./components/vertical-nav-menu-items/VerticalNavMenuItems.vue";
import useVerticalNavMenu from "./useVerticalNavMenu";
import useJwt from "@/auth/jwt/useJwt";
import {initialAbility} from "@/libs/acl/config";
// import { TypeCategories } from '@/@core/utils/utils';

var navMenuItems = [];
export default {
  components: {
    VuePerfectScrollbar,
    VerticalNavMenuItems,
    BLink,
    BImg
  },
  props: {
    isVerticalMenuActive: {
      type: Boolean,
      required: true
    },
    toggleVerticalMenuActive: {
      type: Function,
      required: true
    }
  },
  methods: {
    // getRouteByType(type) {
    //   switch (type) {
    //     case TypeCategories.POLICY:
    //       return 'congtt-list-policies';
    //       break;
    //     case TypeCategories.HELP:
    //       return 'congtt-list-helps';
    //       break;
    //     case TypeCategories.PROMOTION:
    //       return 'congtt-list-promotions';
    //       break;
    //     case TypeCategories.PROCESS_REGULATIONS:
    //       return 'congtt-list-process';
    //       break;
    //     case TypeCategories.PACKDATA:
    //       return 'congtt-pack-data-list';
    //       break;
    //     case TypeCategories.QA:
    //       return 'congtt-qa-list';
    //       break;
    //     default: break;
    //   }
    //   return '';
    // },
    // mockPortal() {
    //   useJwt.get("portal/getAllCategories").then((response) => {
    //     var result = response.data;
    //     if (result.code == 200) {
    //       const listParent = [];
    //       const listChildrent = [];
    //       result.result.forEach(item => {
    //         if (item.cat_type == 0) {
    //           listParent.push(item);
    //         }
    //         else {
    //           listChildrent.push(item);
    //         }
    //       });
    //       listParent.forEach(itemParent => {
    //         this.navMenuItems1.push({
    //           header: itemParent.name,
    //         });
    //         for (var i = 0; i < listChildrent.length; i++) {
    //           const item = listChildrent[i];
    //           if (item.parent_id == itemParent.id) {
    //             var routers = { name: this.getRouteByType(item.cat_type_new), params: { topicId: item.id }, meta: { breadcrumb: item.name } };
    //             this.navMenuItems1.push({
    //               FUNCTION_ORDER: item.sort_order,
    //               ICON: "FileTextIcon",
    //               ID: item.id,
    //               PARENT_ID: item.parent_id,
    //               TITLE: item.name,
    //               route: routers
    //             });
    //           }
    //         }
    //       });
    //     }
    //   });
    // }
    async logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      // await useJwt.logout()

      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)

      // Remove userData from localStorage
      localStorage.removeItem('userData')

      // Reset ability
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({name: 'auth-login'})
    },
  },
  mounted() {
    useJwt
        .get("menu")
        .then(response => {
          this.navMenuItems1 = response.data.result;
          this.navMenuItems1.forEach(item => {
            if (item.route && item.route.includes('/')) {
              item.route = {path: item.route}
            }
          })
          // this.navMenuItems1.splice(2, 0, mockRouteDashboardCampaign);

          // start mock data menu
          // const headerCustomer = { header: "Thông tin khách hàng" };
          // const routeSubscriberInforLookup = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "UserIcon",
          //   ID: 100,
          //   PARENT_ID: 1,
          //   TITLE: "Thông tin khách hàng",
          //   route: "subscriber-information-lookup",
          // };
          // const routeSearchPackage = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "SearchIcon",
          //   ID: 101,
          //   PARENT_ID: 1,
          //   TITLE: "Tra cứu gói cước",
          //   route: "search-package",
          // };
          // const routeSearchCRS = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "SearchIcon",
          //   ID: 102,
          //   PARENT_ID: 1,
          //   TITLE: "Tra cứu CRS",
          //   route: "search-crs",
          // };
          // this.navMenuItems1.push(headerCustomer);
          // this.navMenuItems1.push(routeSubscriberInforLookup);
          // const mockHeaderNews = {
          //   header: "News",
          // };
          // const routerNew = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "PieChartIcon",
          //   ID: 19,
          //   PARENT_ID: 1,
          //   TITLE: "Cổng thông tin iTel",
          //   route: "news-category",
          // };
          // const routerAdmTopics = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "PieChartIcon",
          //   ID: 20,
          //   PARENT_ID: 1,
          //   TITLE: "Quản lý danh mục",
          //   route: "admin-topics",
          // };
          // const routerAdmPosts = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "PieChartIcon",
          //   ID: 21,
          //   PARENT_ID: 1,
          //   TITLE: "Quản lý bài viết",
          //   route: "admin-news",
          // };
          // mock header news
          // this.navMenuItems1.push(mockHeaderNews);
          // // mock menu items news
          // this.navMenuItems1.push(routerNew);
          // this.navMenuItems1.push(routerAdmTopics);
          // this.navMenuItems1.push(routerAdmPosts);
          //mock portal new
          // this.navMenuItems1.push({
          //   header: "Hot News",
          // });
          // const routerHotNew = {
          //   FUNCTION_ORDER: 1,
          //   ICON: "PieChartIcon",
          //   ID: 21,
          //   PARENT_ID: 1,
          //   TITLE: "Tin tức hot",
          //   route: "congtt-hot-new",
          // };
          // this.navMenuItems1.push(routerHotNew);
          // this.mockPortal();
        })
        .catch(error => {
          if (error.response.data.status === 403) {
            this.logout()
          }
        });
  },
  data() {
    return {navMenuItems1: null};
  },
  setup(props) {
    const {
      isMouseHovered,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      updateMouseHovered
    } = useVerticalNavMenu(props);

    const {skin} = useAppConfig();

    // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
    const shallShadowBottom = ref(false);

    provide("isMouseHovered", isMouseHovered);

    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelPropagation: false
    };

    const collapseTogglerIconFeather = computed(() =>
        collapseTogglerIcon.value === "unpinned" ? "CircleIcon" : "DiscIcon"
    );

    // App Name
    const {appName, appLogoImage} = $themeConfig.app;

    return {
      navMenuItems,
      perfectScrollbarSettings,
      isVerticalMenuCollapsed,
      collapseTogglerIcon,
      toggleCollapsed,
      isMouseHovered,
      updateMouseHovered,
      collapseTogglerIconFeather,

      // Shadow Bottom
      shallShadowBottom,

      // Skin
      skin,

      // App Name
      appName,
      appLogoImage
    };
  }
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
